"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnUnmount = void 0;
const react_1 = require("react");
function useOnUnmount(effect) {
    const effectRef = (0, react_1.useRef)(effect);
    // update the ref each render so if it changed the newest callback will be invoked
    effectRef.current = effect;
    (0, react_1.useEffect)(() => {
        return () => {
            effectRef.current();
        };
    }, []);
}
exports.useOnUnmount = useOnUnmount;
